import React, { useEffect, useState } from "react";
import { fetchHeader, fetchSubnav } from "../../containers/common/commonSlice";
import { useDispatch, useSelector } from "react-redux";
import { getCurrentLocal } from "../../utils";

export const Header = () => {
  const dispacth = useDispatch();
  const headerHTML = useSelector((state) => state.common.headerHTML);
  const subNavHTML = useSelector((state) => state.common.subNavHTML);
  const [headerHtmlCode, setHeaderHtmlCode] = useState();
  const [subnavHtmlCode, setSubnavHtmlCode] = useState();
  const getlocales = window.location.href 
	const matchLocal = getlocales.match(/\/([a-z]{2}-[a-z]{2})\//i);
	const locale = matchLocal ? '/'+matchLocal[1] : '';
  useEffect(() => {
    let currentLocale = getCurrentLocal();
    dispacth(fetchHeader(currentLocale.toLowerCase()));
    //dispacth(fetchHeader('en-us'));
    if (window.location.pathname === '/company/newsroom' || window.location.pathname === locale+'/company/newsroom' || window.location.pathname === '/company/distributors' || window.location.pathname === locale+'/company/distributors'  ) {
      dispacth(fetchSubnav(currentLocale.toLowerCase()));
    }
  }, []);
  

  useEffect(() => {
    if(headerHTML){
      let headerBody = headerHTML.querySelector("body");
      let headerMenu = headerBody.querySelectorAll(".sd-mobileMenu a");
      console.log(headerMenu)
      if(headerMenu?.length > 0){
        headerMenu.forEach((menu) => {
          if(window.location.href.includes(menu?.dataset?.highlightId) && menu.querySelector("span")?.classList.contains("sd-bg-gray-101")){
            menu.querySelector("span").classList.remove("sd-bg-gray-101");
            menu.querySelector("span").classList.add("sd-bg-black");
          }
        })
      }
      setHeaderHtmlCode(headerBody.innerHTML);
    }
  }, [headerHTML]);

  useEffect(() => {
    if(subNavHTML){
      let subnavBody = subNavHTML.querySelector("body");
      let subNavMenu = subnavBody.querySelectorAll(".subnav-default a");
      console.log(subNavMenu)
      if(subNavMenu?.length > 0){
        subNavMenu.forEach((menu) => {
          let href = menu.href;
          if(window.location.href.includes(href) && menu.querySelector("span")?.classList.contains("sd-bg-gray-101")){
            menu.querySelector("span").classList.remove("sd-bg-gray-101");
            menu.querySelector("span").classList.add("sd-bg-black");
          }
        })
      }
      setSubnavHtmlCode(subnavBody.innerHTML);
    }
  }, [subNavHTML]);



  
  function closePopupModalWin(e) {
    document.querySelector("#modal-fetch-popup").classList.remove("popupmodal-open");
    document.querySelector("#modal-fetch-popup").classList.remove("center-popup");
    document.querySelector("body").classList.remove("sd-overflow-hidden");
    if(document.querySelector(".popupmodal-close").classList.contains("center-popup-close")){      
      document.querySelector("#modal-fetch-popup").classList.add("sd-hidden");
      document.querySelector(".popupmodal-close").classList.remove("center-popup-close");    
      setTimeout(function(){
        document.querySelector("#modal-fetch-popup").classList.remove("sd-hidden");     
      }, 1000); 
    }
  }

  return (
    <React.Fragment>
      {/* <header className="sd-pt-[17px] sd-pb-[15px] sd-sticky sd-top-0 sd-bg-white sd-z-20 sd-h-12 sd-border-b">
                <div className="sd-container-fluid sd-mx-auto sd-grid sd-grid-cols-16 ">
                    <div className="logo sd-col-span-4">
                        <img src="https://static.sandisk.com/etc.clientlibs/sndsk-static/designs/images/logo/logo.svg" alt="No Preview" />
                    </div>
                    <div className="sd-col-span-12 sd--mt-1 sd-block">
                        <nav className="sd-flex sd-justify-end lg:sd-justify-between sd-items-center sd--mx-2">
                            <div className="sd-w-11/12 sd-flex sd-justify-between sd-items-center sd-absolute lg:sd-relative">
                                <ul className="sd-flex">
                                    <li className="sd-pl-4 sd-hidden lg:sd-block">
                                        <button className="sd-flex sd-items-center sd-text-title sd-group sd-whitespace-nowrap">
                                            <span className="sd-h-[9px] sd-w-[9px] sd-mb-0.5 sd-inline-block sd-mr-[6px] sd-bg-gray-101 group-hover:sd-bg-black">&nbsp;</span>
                                            PORTFOLIO
                                        </button>
                                        <ul className="sd-hidden"></ul>
                                    </li>
                                    <li className="sd-px-4 sd-hidden lg:sd-block">
                                        <button className="sd-flex sd-items-center sd-text-title sd-group sd-whitespace-nowrap"><span className="sd-h-[9px] sd-w-[9px] sd-mb-0.5 sd-inline-block sd-mr-[6px] sd-bg-gray-101 group-hover:sd-bg-black">&nbsp;</span>STORE</button>
                                        <ul className="sd-hidden"></ul>
                                    </li>
                                    <li className="sd-px-4 sd-hidden lg:sd-block">
                                        <button className="sd-flex sd-items-center sd-text-title sd-group sd-whitespace-nowrap"><span className="sd-h-[9px] sd-w-[9px] sd-mb-0.5 sd-inline-block sd-mr-[6px] sd-bg-gray-101 group-hover:sd-bg-black">&nbsp;</span>OFFERS
                                            %</button>
                                        <ul className="sd-hidden"></ul>
                                    </li>
                                    <li className="sd-px-4 sd-hidden lg:sd-block">
                                        <button className="sd-flex sd-items-center sd-text-title sd-group sd-whitespace-nowrap"><span className="sd-h-[9px] sd-w-[9px] sd-mb-0.5 sd-inline-block sd-mr-[6px] sd-bg-gray-101 group-hover:sd-bg-black">&nbsp;</span>COMPANY</button>
                                        <ul className="sd-hidden"></ul>
                                    </li>
                                </ul>
                                <ul className="sd-flex">
                                    <li className="sd-pl-4 sd-hidden lg:sd-block">
                                        <button className="sd-text-title sd-p-1 hover:sd-text-white hover:sd-bg-black sd-whitespace-nowrap">SUPPORT</button>
                                        <ul className="sd-hidden"></ul>
                                    </li>
                                    <li className="sd-pl-4 sd-hidden lg:sd-block">
                                        <button className="sd-text-title sd-p-1 hover:sd-text-white hover:sd-bg-black sd-whitespace-nowrap">EN
                                            / US</button>
                                        <ul className="sd-hidden"></ul>
                                    </li>
                                    <li className="sd-pl-4 sd-hidden lg:sd-block">
                                        <button className="sd-text-title sd-p-1 hover:sd-text-white hover:sd-bg-black sd-whitespace-nowrap">LOGIN</button>
                                        <ul className="sd-hidden"></ul>
                                    </li>
                                </ul>
                            </div>
                            <ul className="sd-flex">
                                <li className="sd-pl-4 sd-block lg:sd-hidden">
                                    <button className="sd-text-title sd-p-1 hover:sd-text-white hover:sd-bg-black sd-whitespace-nowrap">MENU</button>
                                    <ul className="sd-hidden"></ul>
                                </li>
                                <li className="sd-pl-4">
                                    <button className="sd-text-title sd-p-1 hover:sd-text-white hover:sd-bg-black sd-whitespace-nowrap">SEARCH</button>
                                    <ul className="sd-hidden"></ul>
                                </li>
                                <li className="sd-pl-4">
                                    <button className="sd-text-title sd-p-1 hover:sd-text-white hover:sd-bg-black sd-whitespace-nowrap">CART
                                        [3]</button>
                                    <ul className="sd-hidden"></ul>
                                </li>
                            </ul>
                        </nav>
                    </div>
                </div>
            </header> */}
      <header
        class={`sd-min-h-[45px] lg:sd-min-h-[48px] sd-sticky sd-top-0 sd-z-[32] sd-font-[400] ${(window.location.pathname === '/company/newsroom' || window.location.pathname === '/company/distributors') ? "" : "sd-border-b"}`}
        dangerouslySetInnerHTML={{ __html: headerHtmlCode }}
      ></header>
      {(window.location.pathname === '/company/newsroom' || window.location.pathname === locale+'/company/newsroom' || window.location.pathname === '/company/distributors' || window.location.pathname === locale+'/company/distributors' )&& <div
        class="sd-min-h-[45px] lg:sd-min-h-[48px] sd-sticky sd-top-[44px] lg:sd-top-[48px] sd-z-[31] sd-font-[400] sd-border-b"
        dangerouslySetInnerHTML={{ __html: subnavHtmlCode }}
      ></div>}
    </React.Fragment>
  );
};

export default Header;